// TypingIndicatorBubble.jsx
import React from 'react';

import styles from './TypingIndicatorBubble.module.css';

function TypingIndicatorBubble() {
  return (
    <div className={styles.typingBubble}>
      <div className={styles.dotsContainer}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  );
}

export default TypingIndicatorBubble;
